// @flow

export const S_ADDRESS = 'address'
export const S_FLATS = 'flats'
export const S_DWELLERS = 'dwellers'
